import apiClient from '@/services/rest-api-tools/apiClient'

const baseEndpoint = '/encrypt/jwt'

export const store = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data,
  })
  return response
}
